// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: U1WSll_dgG

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import AttentionIndicator from "../../AttentionIndicator"; // plasmic-import: WVm1zuxFAu/component
import AttentionSelection from "../../AttentionSelection"; // plasmic-import: gxplQWBh0N/component
import { LottieWrapper } from "@plasmicpkgs/lottie-react";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSource.module.css"; // plasmic-import: U1WSll_dgG/css

import Iconinfo3Icon from "./icons/PlasmicIcon__Iconinfo3"; // plasmic-import: o9B5nhF6rJ/icon
import IconsDelete3Icon from "./icons/PlasmicIcon__IconsDelete3"; // plasmic-import: AzexPCCfcb/icon
import Add24FilledIcon from "./icons/PlasmicIcon__Add24Filled"; // plasmic-import: W5RSWrKI-W/icon

createPlasmicElementProxy;

export type PlasmicSource__VariantMembers = {
  baseVariant:
    | "notAddedWithDescription"
    | "notAdded"
    | "added"
    | "editing"
    | "adjustAttention"
    | "isCheckingWebsiteSource"
    | "isUnusableWebsiteSource";
  hideHandle: "hideHandle";
  isPlaylist: "isPlaylist";
  hideDeleteButton: "hideDeleteButton";
  editingWithAdminAccess: "editingWithAdminAccess";
  websitesCheckingState: "isChecking";
};
export type PlasmicSource__VariantsArgs = {
  baseVariant?: SingleChoiceArg<
    | "notAddedWithDescription"
    | "notAdded"
    | "added"
    | "editing"
    | "adjustAttention"
    | "isCheckingWebsiteSource"
    | "isUnusableWebsiteSource"
  >;
  hideHandle?: SingleBooleanChoiceArg<"hideHandle">;
  isPlaylist?: SingleBooleanChoiceArg<"isPlaylist">;
  hideDeleteButton?: SingleBooleanChoiceArg<"hideDeleteButton">;
  editingWithAdminAccess?: SingleBooleanChoiceArg<"editingWithAdminAccess">;
  websitesCheckingState?: SingleChoiceArg<"isChecking">;
};
type VariantPropType = keyof PlasmicSource__VariantsArgs;
export const PlasmicSource__VariantProps = new Array<VariantPropType>(
  "baseVariant",
  "hideHandle",
  "isPlaylist",
  "hideDeleteButton",
  "editingWithAdminAccess",
  "websitesCheckingState"
);

export type PlasmicSource__ArgsType = {
  sourceTitle?: React.ReactNode;
  sourceHandle?: React.ReactNode;
  sourceDescription?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSource__ArgsType;
export const PlasmicSource__ArgProps = new Array<ArgPropType>(
  "sourceTitle",
  "sourceHandle",
  "sourceDescription"
);

export type PlasmicSource__OverridesType = {
  root?: p.Flex<"div">;
  sourceContainer?: p.Flex<"div">;
  source?: p.Flex<"div">;
  sourceInner?: p.Flex<"div">;
  sourceAddCircle?: p.Flex<typeof p.PlasmicImg>;
  attentionIndicator?: p.Flex<typeof AttentionIndicator>;
  imageFromUrl?: p.Flex<typeof p.PlasmicImg>;
  sourceTexts?: p.Flex<"div">;
  title?: p.Flex<"div">;
  handle?: p.Flex<"div">;
  link?: p.Flex<"a">;
  editingArea?: p.Flex<"div">;
  adjustAttentionDiv?: p.Flex<"button">;
  adjustAttentionText?: p.Flex<"div">;
  adjustAttentionInfoIcon?: p.Flex<"svg">;
  button?: p.Flex<"button">;
  deleteSourceIcon?: p.Flex<"svg">;
  attentionSelection?: p.Flex<typeof AttentionSelection>;
  addInterestBtn?: p.Flex<"button">;
  edit?: p.Flex<"div">;
  adjustAttentionButton?: p.Flex<"div">;
  adjustAttention?: p.Flex<"div">;
  lottie?: p.Flex<typeof LottieWrapper>;
  logo?: p.Flex<typeof p.PlasmicImg>;
};

export interface DefaultSourceProps {
  sourceTitle?: React.ReactNode;
  sourceHandle?: React.ReactNode;
  sourceDescription?: React.ReactNode;
  baseVariant?: SingleChoiceArg<
    | "notAddedWithDescription"
    | "notAdded"
    | "added"
    | "editing"
    | "adjustAttention"
    | "isCheckingWebsiteSource"
    | "isUnusableWebsiteSource"
  >;
  hideHandle?: SingleBooleanChoiceArg<"hideHandle">;
  isPlaylist?: SingleBooleanChoiceArg<"isPlaylist">;
  hideDeleteButton?: SingleBooleanChoiceArg<"hideDeleteButton">;
  editingWithAdminAccess?: SingleBooleanChoiceArg<"editingWithAdminAccess">;
  websitesCheckingState?: SingleChoiceArg<"isChecking">;
  className?: string;
}

const $$ = {};

function PlasmicSource__RenderFunc(props: {
  variants: PlasmicSource__VariantsArgs;
  args: PlasmicSource__ArgsType;
  overrides: PlasmicSource__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "baseVariant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.baseVariant
      },
      {
        path: "hideHandle",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hideHandle
      },
      {
        path: "isPlaylist",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isPlaylist
      },
      {
        path: "hideDeleteButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.hideDeleteButton
      },
      {
        path: "editingWithAdminAccess",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.editingWithAdminAccess
      },
      {
        path: "websitesCheckingState",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.websitesCheckingState
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootbaseVariant_added]: hasVariant(
            $state,
            "baseVariant",
            "added"
          ),
          [sty.rootbaseVariant_adjustAttention]: hasVariant(
            $state,
            "baseVariant",
            "adjustAttention"
          ),
          [sty.rootbaseVariant_editing]: hasVariant(
            $state,
            "baseVariant",
            "editing"
          ),
          [sty.rootbaseVariant_isCheckingWebsiteSource]: hasVariant(
            $state,
            "baseVariant",
            "isCheckingWebsiteSource"
          ),
          [sty.rootbaseVariant_isUnusableWebsiteSource]: hasVariant(
            $state,
            "baseVariant",
            "isUnusableWebsiteSource"
          ),
          [sty.rootbaseVariant_notAddedWithDescription]: hasVariant(
            $state,
            "baseVariant",
            "notAddedWithDescription"
          ),
          [sty.rooteditingWithAdminAccess]: hasVariant(
            $state,
            "editingWithAdminAccess",
            "editingWithAdminAccess"
          ),
          [sty.rootwebsitesCheckingState_isChecking]: hasVariant(
            $state,
            "websitesCheckingState",
            "isChecking"
          )
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"sourceContainer"}
        data-plasmic-override={overrides.sourceContainer}
        hasGap={true}
        className={classNames(projectcss.all, sty.sourceContainer, {
          [sty.sourceContainerbaseVariant_added]: hasVariant(
            $state,
            "baseVariant",
            "added"
          ),
          [sty.sourceContainerbaseVariant_adjustAttention]: hasVariant(
            $state,
            "baseVariant",
            "adjustAttention"
          ),
          [sty.sourceContainerbaseVariant_editing]: hasVariant(
            $state,
            "baseVariant",
            "editing"
          ),
          [sty.sourceContainerbaseVariant_isCheckingWebsiteSource]: hasVariant(
            $state,
            "baseVariant",
            "isCheckingWebsiteSource"
          ),
          [sty.sourceContainerbaseVariant_isUnusableWebsiteSource]: hasVariant(
            $state,
            "baseVariant",
            "isUnusableWebsiteSource"
          ),
          [sty.sourceContainerbaseVariant_notAddedWithDescription]: hasVariant(
            $state,
            "baseVariant",
            "notAddedWithDescription"
          ),
          [sty.sourceContainerisPlaylist]: hasVariant(
            $state,
            "isPlaylist",
            "isPlaylist"
          )
        })}
      >
        {(
          hasVariant($state, "baseVariant", "isUnusableWebsiteSource")
            ? true
            : hasVariant($state, "baseVariant", "isCheckingWebsiteSource")
            ? true
            : false
        ) ? (
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___1RRim,
              {
                [sty.textbaseVariant_isCheckingWebsiteSource___1RRimxumZ4]:
                  hasVariant($state, "baseVariant", "isCheckingWebsiteSource"),
                [sty.textbaseVariant_isUnusableWebsiteSource___1RRimiImk2]:
                  hasVariant($state, "baseVariant", "isUnusableWebsiteSource")
              }
            )}
          >
            {hasVariant($state, "baseVariant", "isUnusableWebsiteSource")
              ? "checking..."
              : hasVariant($state, "baseVariant", "isCheckingWebsiteSource")
              ? "checking..."
              : "Enter some text"}
          </div>
        ) : null}
        <p.Stack
          as={"div"}
          data-plasmic-name={"source"}
          data-plasmic-override={overrides.source}
          hasGap={true}
          className={classNames(projectcss.all, sty.source, {
            [sty.sourcebaseVariant_added]: hasVariant(
              $state,
              "baseVariant",
              "added"
            ),
            [sty.sourcebaseVariant_adjustAttention]: hasVariant(
              $state,
              "baseVariant",
              "adjustAttention"
            ),
            [sty.sourcebaseVariant_editing]: hasVariant(
              $state,
              "baseVariant",
              "editing"
            ),
            [sty.sourcebaseVariant_isCheckingWebsiteSource]: hasVariant(
              $state,
              "baseVariant",
              "isCheckingWebsiteSource"
            ),
            [sty.sourcebaseVariant_isUnusableWebsiteSource]: hasVariant(
              $state,
              "baseVariant",
              "isUnusableWebsiteSource"
            ),
            [sty.sourcebaseVariant_notAddedWithDescription]: hasVariant(
              $state,
              "baseVariant",
              "notAddedWithDescription"
            ),
            [sty.sourcehideDeleteButton]: hasVariant(
              $state,
              "hideDeleteButton",
              "hideDeleteButton"
            ),
            [sty.sourceisPlaylist]: hasVariant(
              $state,
              "isPlaylist",
              "isPlaylist"
            )
          })}
        >
          <p.Stack
            as={"div"}
            data-plasmic-name={"sourceInner"}
            data-plasmic-override={overrides.sourceInner}
            hasGap={true}
            className={classNames(projectcss.all, sty.sourceInner, {
              [sty.sourceInnerbaseVariant_added]: hasVariant(
                $state,
                "baseVariant",
                "added"
              ),
              [sty.sourceInnerbaseVariant_adjustAttention]: hasVariant(
                $state,
                "baseVariant",
                "adjustAttention"
              ),
              [sty.sourceInnerbaseVariant_editing]: hasVariant(
                $state,
                "baseVariant",
                "editing"
              ),
              [sty.sourceInnerbaseVariant_isCheckingWebsiteSource]: hasVariant(
                $state,
                "baseVariant",
                "isCheckingWebsiteSource"
              ),
              [sty.sourceInnerbaseVariant_isUnusableWebsiteSource]: hasVariant(
                $state,
                "baseVariant",
                "isUnusableWebsiteSource"
              ),
              [sty.sourceInnerisPlaylist]: hasVariant(
                $state,
                "isPlaylist",
                "isPlaylist"
              ),
              [sty.sourceInnerwebsitesCheckingState_isChecking]: hasVariant(
                $state,
                "websitesCheckingState",
                "isChecking"
              )
            })}
          >
            {(
              hasVariant($state, "websitesCheckingState", "isChecking")
                ? false
                : hasVariant($state, "baseVariant", "isUnusableWebsiteSource")
                ? false
                : hasVariant($state, "baseVariant", "isCheckingWebsiteSource")
                ? false
                : hasVariant($state, "baseVariant", "adjustAttention")
                ? false
                : hasVariant($state, "baseVariant", "editing")
                ? false
                : hasVariant($state, "baseVariant", "added")
                ? false
                : true
            ) ? (
              <p.PlasmicImg
                data-plasmic-name={"sourceAddCircle"}
                data-plasmic-override={overrides.sourceAddCircle}
                alt={""}
                className={classNames(sty.sourceAddCircle, {
                  [sty.sourceAddCirclebaseVariant_added]: hasVariant(
                    $state,
                    "baseVariant",
                    "added"
                  ),
                  [sty.sourceAddCirclebaseVariant_adjustAttention]: hasVariant(
                    $state,
                    "baseVariant",
                    "adjustAttention"
                  ),
                  [sty.sourceAddCirclebaseVariant_editing]: hasVariant(
                    $state,
                    "baseVariant",
                    "editing"
                  ),
                  [sty.sourceAddCirclebaseVariant_isCheckingWebsiteSource]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "isCheckingWebsiteSource"
                    ),
                  [sty.sourceAddCirclebaseVariant_isUnusableWebsiteSource]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "isUnusableWebsiteSource"
                    ),
                  [sty.sourceAddCirclebaseVariant_notAddedWithDescription]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "notAddedWithDescription"
                    ),
                  [sty.sourceAddCirclebaseVariant_notAdded]: hasVariant(
                    $state,
                    "baseVariant",
                    "notAdded"
                  ),
                  [sty.sourceAddCircleisPlaylist]: hasVariant(
                    $state,
                    "isPlaylist",
                    "isPlaylist"
                  ),
                  [sty.sourceAddCirclewebsitesCheckingState_isChecking]:
                    hasVariant($state, "websitesCheckingState", "isChecking")
                })}
                displayHeight={"0.7em"}
                displayMaxHeight={"none"}
                displayMaxWidth={"none"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"0.66em"}
                loader={"plasmic"}
                src={{
                  src: "https://site-assets.plasmic.app/942f97b5d325e0ae87495974717a2a09.svg",
                  fullWidth: 7,
                  fullHeight: 7,
                  aspectRatio: 1
                }}
              />
            ) : null}
            <AttentionIndicator
              data-plasmic-name={"attentionIndicator"}
              data-plasmic-override={overrides.attentionIndicator}
              className={classNames("__wab_instance", sty.attentionIndicator, {
                [sty.attentionIndicatorbaseVariant_added]: hasVariant(
                  $state,
                  "baseVariant",
                  "added"
                ),
                [sty.attentionIndicatorbaseVariant_adjustAttention]: hasVariant(
                  $state,
                  "baseVariant",
                  "adjustAttention"
                ),
                [sty.attentionIndicatorbaseVariant_editing]: hasVariant(
                  $state,
                  "baseVariant",
                  "editing"
                ),
                [sty.attentionIndicatorbaseVariant_isCheckingWebsiteSource]:
                  hasVariant($state, "baseVariant", "isCheckingWebsiteSource"),
                [sty.attentionIndicatorbaseVariant_isUnusableWebsiteSource]:
                  hasVariant($state, "baseVariant", "isUnusableWebsiteSource"),
                [sty.attentionIndicatorbaseVariant_notAddedWithDescription]:
                  hasVariant($state, "baseVariant", "notAddedWithDescription"),
                [sty.attentionIndicatorbaseVariant_notAdded]: hasVariant(
                  $state,
                  "baseVariant",
                  "notAdded"
                )
              })}
              level={"_1"}
            />

            {(hasVariant($state, "isPlaylist", "isPlaylist") ? false : true) ? (
              <p.PlasmicImg
                data-plasmic-name={"imageFromUrl"}
                data-plasmic-override={overrides.imageFromUrl}
                alt={""}
                className={classNames(sty.imageFromUrl, {
                  [sty.imageFromUrlbaseVariant_added]: hasVariant(
                    $state,
                    "baseVariant",
                    "added"
                  ),
                  [sty.imageFromUrlbaseVariant_editing]: hasVariant(
                    $state,
                    "baseVariant",
                    "editing"
                  ),
                  [sty.imageFromUrlbaseVariant_isCheckingWebsiteSource]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "isCheckingWebsiteSource"
                    ),
                  [sty.imageFromUrlbaseVariant_isUnusableWebsiteSource]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "isUnusableWebsiteSource"
                    ),
                  [sty.imageFromUrlbaseVariant_notAddedWithDescription]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "notAddedWithDescription"
                    ),
                  [sty.imageFromUrlbaseVariant_notAdded]: hasVariant(
                    $state,
                    "baseVariant",
                    "notAdded"
                  ),
                  [sty.imageFromUrlisPlaylist]: hasVariant(
                    $state,
                    "isPlaylist",
                    "isPlaylist"
                  )
                })}
                displayHeight={"1.5em"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"1.5em"}
                id={
                  hasVariant($state, "baseVariant", "notAddedWithDescription")
                    ? "image"
                    : undefined
                }
                loader={"plasmic"}
                loading={"lazy"}
              />
            ) : null}
            {(
              hasVariant($state, "baseVariant", "adjustAttention")
                ? false
                : hasVariant($state, "baseVariant", "editing")
                ? false
                : true
            ) ? (
              <div
                data-plasmic-name={"sourceTexts"}
                data-plasmic-override={overrides.sourceTexts}
                className={classNames(projectcss.all, sty.sourceTexts, {
                  [sty.sourceTextsbaseVariant_adjustAttention]: hasVariant(
                    $state,
                    "baseVariant",
                    "adjustAttention"
                  ),
                  [sty.sourceTextsbaseVariant_editing]: hasVariant(
                    $state,
                    "baseVariant",
                    "editing"
                  ),
                  [sty.sourceTextsbaseVariant_isCheckingWebsiteSource]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "isCheckingWebsiteSource"
                    ),
                  [sty.sourceTextsbaseVariant_isUnusableWebsiteSource]:
                    hasVariant(
                      $state,
                      "baseVariant",
                      "isUnusableWebsiteSource"
                    ),
                  [sty.sourceTextsisPlaylist]: hasVariant(
                    $state,
                    "isPlaylist",
                    "isPlaylist"
                  )
                })}
              >
                <div
                  data-plasmic-name={"title"}
                  data-plasmic-override={overrides.title}
                  className={classNames(projectcss.all, sty.title)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: (
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__aXuss
                        )}
                      >
                        {"Chris Sacca"}
                      </div>
                    ),
                    value: args.sourceTitle,
                    className: classNames(sty.slotTargetSourceTitle, {
                      [sty.slotTargetSourceTitlebaseVariant_added]: hasVariant(
                        $state,
                        "baseVariant",
                        "added"
                      ),
                      [sty.slotTargetSourceTitlebaseVariant_adjustAttention]:
                        hasVariant($state, "baseVariant", "adjustAttention"),
                      [sty.slotTargetSourceTitlebaseVariant_editing]:
                        hasVariant($state, "baseVariant", "editing"),
                      [sty.slotTargetSourceTitlebaseVariant_isCheckingWebsiteSource]:
                        hasVariant(
                          $state,
                          "baseVariant",
                          "isCheckingWebsiteSource"
                        ),
                      [sty.slotTargetSourceTitlebaseVariant_isUnusableWebsiteSource]:
                        hasVariant(
                          $state,
                          "baseVariant",
                          "isUnusableWebsiteSource"
                        ),
                      [sty.slotTargetSourceTitleeditingWithAdminAccess]:
                        hasVariant(
                          $state,
                          "editingWithAdminAccess",
                          "editingWithAdminAccess"
                        ),
                      [sty.slotTargetSourceTitleisPlaylist]: hasVariant(
                        $state,
                        "isPlaylist",
                        "isPlaylist"
                      )
                    })
                  })}
                </div>
                <div
                  data-plasmic-name={"handle"}
                  data-plasmic-override={overrides.handle}
                  className={classNames(projectcss.all, sty.handle, {
                    [sty.handlebaseVariant_adjustAttention]: hasVariant(
                      $state,
                      "baseVariant",
                      "adjustAttention"
                    ),
                    [sty.handlebaseVariant_editing]: hasVariant(
                      $state,
                      "baseVariant",
                      "editing"
                    )
                  })}
                >
                  <a
                    data-plasmic-name={"link"}
                    data-plasmic-override={overrides.link}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link,
                      {
                        [sty.linkbaseVariant_added]: hasVariant(
                          $state,
                          "baseVariant",
                          "added"
                        ),
                        [sty.linkbaseVariant_adjustAttention]: hasVariant(
                          $state,
                          "baseVariant",
                          "adjustAttention"
                        ),
                        [sty.linkbaseVariant_editing]: hasVariant(
                          $state,
                          "baseVariant",
                          "editing"
                        ),
                        [sty.linkbaseVariant_isCheckingWebsiteSource]:
                          hasVariant(
                            $state,
                            "baseVariant",
                            "isCheckingWebsiteSource"
                          ),
                        [sty.linkbaseVariant_isUnusableWebsiteSource]:
                          hasVariant(
                            $state,
                            "baseVariant",
                            "isUnusableWebsiteSource"
                          ),
                        [sty.linkbaseVariant_notAddedWithDescription]:
                          hasVariant(
                            $state,
                            "baseVariant",
                            "notAddedWithDescription"
                          ),
                        [sty.linkhideHandle]: hasVariant(
                          $state,
                          "hideHandle",
                          "hideHandle"
                        )
                      }
                    )}
                  >
                    {(
                      hasVariant($state, "isPlaylist", "isPlaylist")
                        ? false
                        : true
                    )
                      ? p.renderPlasmicSlot({
                          defaultContents: (
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__sp5XU
                              )}
                            >
                              {"@sacca"}
                            </div>
                          ),
                          value: args.sourceHandle,
                          className: classNames(sty.slotTargetSourceHandle, {
                            [sty.slotTargetSourceHandlebaseVariant_added]:
                              hasVariant($state, "baseVariant", "added"),
                            [sty.slotTargetSourceHandlebaseVariant_adjustAttention]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "adjustAttention"
                              ),
                            [sty.slotTargetSourceHandlebaseVariant_editing]:
                              hasVariant($state, "baseVariant", "editing"),
                            [sty.slotTargetSourceHandlebaseVariant_isCheckingWebsiteSource]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "isCheckingWebsiteSource"
                              ),
                            [sty.slotTargetSourceHandlebaseVariant_isUnusableWebsiteSource]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "isUnusableWebsiteSource"
                              ),
                            [sty.slotTargetSourceHandlebaseVariant_notAddedWithDescription]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "notAddedWithDescription"
                              ),
                            [sty.slotTargetSourceHandlehideHandle]: hasVariant(
                              $state,
                              "hideHandle",
                              "hideHandle"
                            ),
                            [sty.slotTargetSourceHandleisPlaylist]: hasVariant(
                              $state,
                              "isPlaylist",
                              "isPlaylist"
                            )
                          })
                        })
                      : null}
                  </a>
                </div>
              </div>
            ) : null}
            {(
              hasVariant(
                $state,
                "editingWithAdminAccess",
                "editingWithAdminAccess"
              )
                ? true
                : hasVariant($state, "baseVariant", "adjustAttention")
                ? true
                : hasVariant($state, "baseVariant", "editing")
                ? true
                : false
            ) ? (
              <p.Stack
                as={"div"}
                data-plasmic-name={"editingArea"}
                data-plasmic-override={overrides.editingArea}
                hasGap={true}
                className={classNames(projectcss.all, sty.editingArea, {
                  [sty.editingAreabaseVariant_adjustAttention]: hasVariant(
                    $state,
                    "baseVariant",
                    "adjustAttention"
                  ),
                  [sty.editingAreabaseVariant_editing]: hasVariant(
                    $state,
                    "baseVariant",
                    "editing"
                  ),
                  [sty.editingAreaeditingWithAdminAccess]: hasVariant(
                    $state,
                    "editingWithAdminAccess",
                    "editingWithAdminAccess"
                  )
                })}
              >
                {(
                  hasVariant($state, "baseVariant", "adjustAttention")
                    ? false
                    : hasVariant($state, "baseVariant", "editing")
                    ? true
                    : false
                ) ? (
                  <p.Stack
                    as={"button"}
                    data-plasmic-name={"adjustAttentionDiv"}
                    data-plasmic-override={overrides.adjustAttentionDiv}
                    hasGap={true}
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      sty.adjustAttentionDiv,
                      {
                        [sty.adjustAttentionDivbaseVariant_adjustAttention]:
                          hasVariant($state, "baseVariant", "adjustAttention"),
                        [sty.adjustAttentionDivbaseVariant_editing]: hasVariant(
                          $state,
                          "baseVariant",
                          "editing"
                        )
                      }
                    )}
                    ref={ref => {
                      $refs["adjustAttentionDiv"] = ref;
                    }}
                  >
                    {(
                      hasVariant($state, "baseVariant", "adjustAttention")
                        ? true
                        : hasVariant($state, "baseVariant", "editing")
                        ? true
                        : false
                    ) ? (
                      <div
                        data-plasmic-name={"adjustAttentionText"}
                        data-plasmic-override={overrides.adjustAttentionText}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.adjustAttentionText,
                          {
                            [sty.adjustAttentionTextbaseVariant_adjustAttention]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "adjustAttention"
                              ),
                            [sty.adjustAttentionTextbaseVariant_editing]:
                              hasVariant($state, "baseVariant", "editing")
                          }
                        )}
                      >
                        {hasVariant($state, "baseVariant", "adjustAttention")
                          ? "adjust attention"
                          : hasVariant($state, "baseVariant", "editing")
                          ? "adjust attention"
                          : "Enter some text"}
                      </div>
                    ) : null}
                    {(
                      hasVariant($state, "baseVariant", "adjustAttention")
                        ? true
                        : hasVariant($state, "baseVariant", "editing")
                        ? true
                        : false
                    ) ? (
                      <Iconinfo3Icon
                        data-plasmic-name={"adjustAttentionInfoIcon"}
                        data-plasmic-override={
                          overrides.adjustAttentionInfoIcon
                        }
                        className={classNames(
                          projectcss.all,
                          sty.adjustAttentionInfoIcon,
                          {
                            [sty.adjustAttentionInfoIconbaseVariant_adjustAttention]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "adjustAttention"
                              ),
                            [sty.adjustAttentionInfoIconbaseVariant_editing]:
                              hasVariant($state, "baseVariant", "editing")
                          }
                        )}
                        role={"img"}
                      />
                    ) : null}
                  </p.Stack>
                ) : null}
                {(
                  hasVariant($state, "hideDeleteButton", "hideDeleteButton") &&
                  hasVariant($state, "baseVariant", "editing")
                    ? false
                    : hasVariant($state, "baseVariant", "adjustAttention")
                    ? false
                    : hasVariant($state, "baseVariant", "editing")
                    ? true
                    : true
                ) ? (
                  <button
                    data-plasmic-name={"button"}
                    data-plasmic-override={overrides.button}
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      sty.button,
                      {
                        [sty.buttonbaseVariant_adjustAttention]: hasVariant(
                          $state,
                          "baseVariant",
                          "adjustAttention"
                        ),
                        [sty.buttonbaseVariant_editing]: hasVariant(
                          $state,
                          "baseVariant",
                          "editing"
                        ),
                        [sty.buttonbaseVariant_editing_hideDeleteButton]:
                          hasVariant(
                            $state,
                            "hideDeleteButton",
                            "hideDeleteButton"
                          ) && hasVariant($state, "baseVariant", "editing"),
                        [sty.buttoneditingWithAdminAccess]: hasVariant(
                          $state,
                          "editingWithAdminAccess",
                          "editingWithAdminAccess"
                        )
                      }
                    )}
                  >
                    {(
                      hasVariant(
                        $state,
                        "hideDeleteButton",
                        "hideDeleteButton"
                      ) && hasVariant($state, "baseVariant", "editing")
                        ? false
                        : hasVariant(
                            $state,
                            "editingWithAdminAccess",
                            "editingWithAdminAccess"
                          )
                        ? true
                        : hasVariant($state, "baseVariant", "adjustAttention")
                        ? false
                        : hasVariant($state, "baseVariant", "editing")
                        ? true
                        : false
                    ) ? (
                      <IconsDelete3Icon
                        data-plasmic-name={"deleteSourceIcon"}
                        data-plasmic-override={overrides.deleteSourceIcon}
                        className={classNames(
                          projectcss.all,
                          sty.deleteSourceIcon,
                          {
                            [sty.deleteSourceIconbaseVariant_adjustAttention]:
                              hasVariant(
                                $state,
                                "baseVariant",
                                "adjustAttention"
                              ),
                            [sty.deleteSourceIconbaseVariant_editing]:
                              hasVariant($state, "baseVariant", "editing"),
                            [sty.deleteSourceIconbaseVariant_editing_hideDeleteButton]:
                              hasVariant(
                                $state,
                                "hideDeleteButton",
                                "hideDeleteButton"
                              ) && hasVariant($state, "baseVariant", "editing"),
                            [sty.deleteSourceIconeditingWithAdminAccess]:
                              hasVariant(
                                $state,
                                "editingWithAdminAccess",
                                "editingWithAdminAccess"
                              )
                          }
                        )}
                        role={"img"}
                      />
                    ) : null}
                  </button>
                ) : null}
                {(
                  hasVariant($state, "baseVariant", "adjustAttention")
                    ? true
                    : false
                ) ? (
                  <AttentionSelection
                    data-plasmic-name={"attentionSelection"}
                    data-plasmic-override={overrides.attentionSelection}
                  />
                ) : null}
                <button
                  data-plasmic-name={"addInterestBtn"}
                  data-plasmic-override={overrides.addInterestBtn}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.addInterestBtn,
                    {
                      [sty.addInterestBtnbaseVariant_adjustAttention]:
                        hasVariant($state, "baseVariant", "adjustAttention"),
                      [sty.addInterestBtnbaseVariant_editing]: hasVariant(
                        $state,
                        "baseVariant",
                        "editing"
                      ),
                      [sty.addInterestBtneditingWithAdminAccess]: hasVariant(
                        $state,
                        "editingWithAdminAccess",
                        "editingWithAdminAccess"
                      )
                    }
                  )}
                  ref={ref => {
                    $refs["addInterestBtn"] = ref;
                  }}
                >
                  <Add24FilledIcon
                    className={classNames(projectcss.all, sty.svg__rrO4K, {
                      [sty.svgbaseVariant_editing__rrO4KjnBbX]: hasVariant(
                        $state,
                        "baseVariant",
                        "editing"
                      ),
                      [sty.svgeditingWithAdminAccess__rrO4K98Llt]: hasVariant(
                        $state,
                        "editingWithAdminAccess",
                        "editingWithAdminAccess"
                      )
                    })}
                    role={"img"}
                  />
                </button>
              </p.Stack>
            ) : null}
            {(
              hasVariant($state, "baseVariant", "adjustAttention")
                ? false
                : hasVariant($state, "baseVariant", "editing")
                ? false
                : false
            ) ? (
              <p.Stack
                as={"div"}
                data-plasmic-name={"edit"}
                data-plasmic-override={overrides.edit}
                hasGap={true}
                className={classNames(projectcss.all, sty.edit, {
                  [sty.editbaseVariant_adjustAttention]: hasVariant(
                    $state,
                    "baseVariant",
                    "adjustAttention"
                  ),
                  [sty.editbaseVariant_editing]: hasVariant(
                    $state,
                    "baseVariant",
                    "editing"
                  )
                })}
              >
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"adjustAttentionButton"}
                  data-plasmic-override={overrides.adjustAttentionButton}
                  hasGap={true}
                  className={classNames(
                    projectcss.all,
                    sty.adjustAttentionButton,
                    {
                      [sty.adjustAttentionButtonbaseVariant_adjustAttention]:
                        hasVariant($state, "baseVariant", "adjustAttention"),
                      [sty.adjustAttentionButtonbaseVariant_editing]:
                        hasVariant($state, "baseVariant", "editing")
                    }
                  )}
                >
                  <div
                    data-plasmic-name={"adjustAttention"}
                    data-plasmic-override={overrides.adjustAttention}
                    className={classNames(projectcss.all, sty.adjustAttention, {
                      [sty.adjustAttentionbaseVariant_adjustAttention]:
                        hasVariant($state, "baseVariant", "adjustAttention"),
                      [sty.adjustAttentionbaseVariant_editing]: hasVariant(
                        $state,
                        "baseVariant",
                        "editing"
                      )
                    })}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__yigYs,
                        {
                          [sty.textbaseVariant_adjustAttention__yigYsaQs6Q]:
                            hasVariant(
                              $state,
                              "baseVariant",
                              "adjustAttention"
                            ),
                          [sty.textbaseVariant_editing__yigYSjnBbX]: hasVariant(
                            $state,
                            "baseVariant",
                            "editing"
                          )
                        }
                      )}
                    >
                      {"adjust attention"}
                    </div>
                  </div>
                  {(
                    hasVariant($state, "baseVariant", "adjustAttention")
                      ? false
                      : hasVariant($state, "baseVariant", "editing")
                      ? false
                      : false
                  ) ? (
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox__wEmDu,
                        {
                          [sty.freeBoxbaseVariant_adjustAttention__wEmDuaQs6Q]:
                            hasVariant(
                              $state,
                              "baseVariant",
                              "adjustAttention"
                            ),
                          [sty.freeBoxbaseVariant_editing__wEmDUjnBbX]:
                            hasVariant($state, "baseVariant", "editing")
                        }
                      )}
                    />
                  ) : null}
                  {(
                    hasVariant($state, "baseVariant", "adjustAttention")
                      ? true
                      : hasVariant($state, "baseVariant", "editing")
                      ? true
                      : false
                  ) ? (
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___9MibO,
                        {
                          [sty.freeBoxbaseVariant_adjustAttention___9MibOaQs6Q]:
                            hasVariant(
                              $state,
                              "baseVariant",
                              "adjustAttention"
                            ),
                          [sty.freeBoxbaseVariant_editing___9MibOjnBbX]:
                            hasVariant($state, "baseVariant", "editing")
                        }
                      )}
                    >
                      {(
                        hasVariant($state, "baseVariant", "adjustAttention")
                          ? true
                          : hasVariant($state, "baseVariant", "editing")
                          ? true
                          : false
                      ) ? (
                        <Iconinfo3Icon
                          className={classNames(
                            projectcss.all,
                            sty.svg__xLeCh,
                            {
                              [sty.svgbaseVariant_adjustAttention__xLeChaQs6Q]:
                                hasVariant(
                                  $state,
                                  "baseVariant",
                                  "adjustAttention"
                                ),
                              [sty.svgbaseVariant_editing__xLeCHjnBbX]:
                                hasVariant($state, "baseVariant", "editing")
                            }
                          )}
                          role={"img"}
                        />
                      ) : null}
                    </div>
                  ) : null}
                </p.Stack>
                {(
                  hasVariant($state, "baseVariant", "adjustAttention")
                    ? true
                    : hasVariant($state, "baseVariant", "editing")
                    ? true
                    : false
                ) ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__fIvr, {
                      [sty.freeBoxbaseVariant_adjustAttention__fIvraQs6Q]:
                        hasVariant($state, "baseVariant", "adjustAttention"),
                      [sty.freeBoxbaseVariant_editing__fIvRjnBbX]: hasVariant(
                        $state,
                        "baseVariant",
                        "editing"
                      )
                    })}
                  >
                    {(
                      hasVariant($state, "baseVariant", "adjustAttention")
                        ? true
                        : hasVariant($state, "baseVariant", "editing")
                        ? true
                        : false
                    ) ? (
                      <IconsDelete3Icon
                        className={classNames(projectcss.all, sty.svg__lg79I, {
                          [sty.svgbaseVariant_adjustAttention__lg79IaQs6Q]:
                            hasVariant(
                              $state,
                              "baseVariant",
                              "adjustAttention"
                            ),
                          [sty.svgbaseVariant_editing__lg79IjnBbX]: hasVariant(
                            $state,
                            "baseVariant",
                            "editing"
                          )
                        })}
                        role={"img"}
                      />
                    ) : null}
                  </div>
                ) : null}
              </p.Stack>
            ) : null}
            {(
              hasVariant($state, "baseVariant", "isUnusableWebsiteSource")
                ? false
                : hasVariant($state, "baseVariant", "isCheckingWebsiteSource")
                ? true
                : true
            ) ? (
              <LottieWrapper
                data-plasmic-name={"lottie"}
                data-plasmic-override={overrides.lottie}
                animationData={{
                  nm: "Loading spinner BLUE",
                  ddd: 0,
                  h: 50,
                  w: 50,
                  meta: { g: "@lottiefiles/toolkit-js 0.33.2" },
                  layers: [
                    {
                      ty: 4,
                      nm: "Shape Layer 1",
                      sr: 1,
                      st: 0,
                      op: 300,
                      ip: 0,
                      hd: false,
                      ddd: 0,
                      bm: 0,
                      hasMask: false,
                      ao: 0,
                      ks: {
                        a: { a: 0, k: [3.178, 3.178, 0], ix: 1 },
                        s: { a: 0, k: [92.283, 92.283, 100], ix: 6 },
                        sk: { a: 0, k: 0 },
                        p: { a: 0, k: [25, 25, 0], ix: 2 },
                        r: { a: 0, k: 0, ix: 10 },
                        sa: { a: 0, k: 0 },
                        o: { a: 0, k: 100, ix: 11 }
                      },
                      ef: [],
                      shapes: [
                        {
                          ty: "gr",
                          bm: 0,
                          hd: false,
                          mn: "ADBE Vector Group",
                          nm: "Ellipse 1",
                          ix: 1,
                          cix: 2,
                          np: 3,
                          it: [
                            {
                              ty: "el",
                              bm: 0,
                              hd: false,
                              mn: "ADBE Vector Shape - Ellipse",
                              nm: "Ellipse Path 1",
                              d: 1,
                              p: { a: 0, k: [0, 0], ix: 3 },
                              s: { a: 0, k: [45.356, 45.356], ix: 2 }
                            },
                            {
                              ty: "st",
                              bm: 0,
                              hd: false,
                              mn: "ADBE Vector Graphic - Stroke",
                              nm: "Stroke 1",
                              lc: 2,
                              lj: 2,
                              ml: 1,
                              o: { a: 0, k: 100, ix: 4 },
                              w: { a: 0, k: 7, ix: 5 },
                              c: { a: 0, k: [0.349, 0.4706, 0.9098], ix: 3 }
                            },
                            {
                              ty: "tr",
                              a: { a: 0, k: [0, 0], ix: 1 },
                              s: { a: 0, k: [100, 100], ix: 3 },
                              sk: { a: 0, k: 0, ix: 4 },
                              p: { a: 0, k: [3.178, 3.178], ix: 2 },
                              r: { a: 0, k: 0, ix: 6 },
                              sa: { a: 0, k: 0, ix: 5 },
                              o: { a: 0, k: 100, ix: 7 }
                            }
                          ]
                        },
                        {
                          ty: "tm",
                          bm: 0,
                          hd: false,
                          mn: "ADBE Vector Filter - Trim",
                          nm: "Trim Paths 1",
                          ix: 2,
                          e: {
                            a: 1,
                            k: [
                              {
                                o: { x: 0.362, y: 0.158 },
                                i: { x: 0.17, y: 1 },
                                s: [0.1],
                                t: 0
                              },
                              { s: [100], t: 40 }
                            ],
                            ix: 2
                          },
                          o: {
                            a: 1,
                            k: [
                              {
                                o: { x: 0.75, y: 0.35 },
                                i: { x: 0.166, y: 0.61 },
                                s: [0],
                                t: 0
                              },
                              { s: [360], t: 50 }
                            ],
                            ix: 3
                          },
                          s: {
                            a: 1,
                            k: [
                              {
                                o: { x: 0.333, y: 0 },
                                i: { x: 0.335, y: 1 },
                                s: [0],
                                t: 15
                              },
                              { s: [100], t: 50 }
                            ],
                            ix: 1
                          },
                          m: 1
                        }
                      ],
                      ind: 1
                    }
                  ],
                  v: "5.7.5",
                  fr: 30,
                  op: 50,
                  ip: 0,
                  assets: []
                }}
                className={classNames("__wab_instance", sty.lottie, {
                  [sty.lottiebaseVariant_isCheckingWebsiteSource]: hasVariant(
                    $state,
                    "baseVariant",
                    "isCheckingWebsiteSource"
                  ),
                  [sty.lottiebaseVariant_isUnusableWebsiteSource]: hasVariant(
                    $state,
                    "baseVariant",
                    "isUnusableWebsiteSource"
                  )
                })}
                preview={true}
              />
            ) : null}
          </p.Stack>
          {(
            hasVariant($state, "websitesCheckingState", "isChecking")
              ? false
              : hasVariant(
                  $state,
                  "editingWithAdminAccess",
                  "editingWithAdminAccess"
                )
              ? true
              : hasVariant($state, "baseVariant", "isUnusableWebsiteSource")
              ? true
              : hasVariant($state, "baseVariant", "isCheckingWebsiteSource")
              ? true
              : hasVariant($state, "baseVariant", "adjustAttention")
              ? false
              : hasVariant($state, "baseVariant", "editing")
              ? true
              : hasVariant($state, "baseVariant", "added")
              ? true
              : hasVariant($state, "baseVariant", "notAdded")
              ? true
              : true
          ) ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__je9Lb, {
                [sty.freeBoxbaseVariant_added__je9Lb5Z0ZB]: hasVariant(
                  $state,
                  "baseVariant",
                  "added"
                ),
                [sty.freeBoxbaseVariant_adjustAttention__je9LbAQs6Q]:
                  hasVariant($state, "baseVariant", "adjustAttention"),
                [sty.freeBoxbaseVariant_editing__je9LbjnBbX]: hasVariant(
                  $state,
                  "baseVariant",
                  "editing"
                ),
                [sty.freeBoxbaseVariant_isCheckingWebsiteSource__je9LbxumZ4]:
                  hasVariant($state, "baseVariant", "isCheckingWebsiteSource"),
                [sty.freeBoxbaseVariant_isUnusableWebsiteSource__je9LbiImk2]:
                  hasVariant($state, "baseVariant", "isUnusableWebsiteSource"),
                [sty.freeBoxbaseVariant_notAddedWithDescription__je9LbrK9Ev]:
                  hasVariant($state, "baseVariant", "notAddedWithDescription"),
                [sty.freeBoxbaseVariant_notAdded__je9LbDeW6L]: hasVariant(
                  $state,
                  "baseVariant",
                  "notAdded"
                ),
                [sty.freeBoxeditingWithAdminAccess__je9Lb98Llt]: hasVariant(
                  $state,
                  "editingWithAdminAccess",
                  "editingWithAdminAccess"
                ),
                [sty.freeBoxisPlaylist__je9LbSh5F]: hasVariant(
                  $state,
                  "isPlaylist",
                  "isPlaylist"
                ),
                [sty.freeBoxwebsitesCheckingState_isChecking__je9LbvRMj]:
                  hasVariant($state, "websitesCheckingState", "isChecking")
              })}
            >
              {(
                hasVariant($state, "baseVariant", "isUnusableWebsiteSource")
                  ? false
                  : hasVariant($state, "baseVariant", "isCheckingWebsiteSource")
                  ? false
                  : hasVariant($state, "baseVariant", "editing")
                  ? false
                  : hasVariant($state, "baseVariant", "added")
                  ? false
                  : true
              )
                ? p.renderPlasmicSlot({
                    defaultContents: (
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___2Aggw
                        )}
                      >
                        {
                          "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                        }
                      </div>
                    ),
                    value: args.sourceDescription,
                    className: classNames(sty.slotTargetSourceDescription, {
                      [sty.slotTargetSourceDescriptionbaseVariant_added]:
                        hasVariant($state, "baseVariant", "added"),
                      [sty.slotTargetSourceDescriptionbaseVariant_adjustAttention]:
                        hasVariant($state, "baseVariant", "adjustAttention"),
                      [sty.slotTargetSourceDescriptionbaseVariant_editing]:
                        hasVariant($state, "baseVariant", "editing"),
                      [sty.slotTargetSourceDescriptionbaseVariant_editing_hideDeleteButton]:
                        hasVariant(
                          $state,
                          "hideDeleteButton",
                          "hideDeleteButton"
                        ) && hasVariant($state, "baseVariant", "editing"),
                      [sty.slotTargetSourceDescriptionbaseVariant_isCheckingWebsiteSource]:
                        hasVariant(
                          $state,
                          "baseVariant",
                          "isCheckingWebsiteSource"
                        ),
                      [sty.slotTargetSourceDescriptionbaseVariant_isUnusableWebsiteSource]:
                        hasVariant(
                          $state,
                          "baseVariant",
                          "isUnusableWebsiteSource"
                        ),
                      [sty.slotTargetSourceDescriptionbaseVariant_notAddedWithDescription]:
                        hasVariant(
                          $state,
                          "baseVariant",
                          "notAddedWithDescription"
                        ),
                      [sty.slotTargetSourceDescriptionbaseVariant_notAdded]:
                        hasVariant($state, "baseVariant", "notAdded"),
                      [sty.slotTargetSourceDescriptioneditingWithAdminAccess]:
                        hasVariant(
                          $state,
                          "editingWithAdminAccess",
                          "editingWithAdminAccess"
                        ),
                      [sty.slotTargetSourceDescriptionhideHandle]: hasVariant(
                        $state,
                        "hideHandle",
                        "hideHandle"
                      ),
                      [sty.slotTargetSourceDescriptionisPlaylist]: hasVariant(
                        $state,
                        "isPlaylist",
                        "isPlaylist"
                      ),
                      [sty.slotTargetSourceDescriptionwebsitesCheckingState_isChecking]:
                        hasVariant(
                          $state,
                          "websitesCheckingState",
                          "isChecking"
                        )
                    })
                  })
                : null}
            </div>
          ) : null}
          <p.PlasmicImg
            data-plasmic-name={"logo"}
            data-plasmic-override={overrides.logo}
            alt={""}
            className={classNames(sty.logo)}
            displayHeight={"1em"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"1em"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://img.plasmic.app/img-optimizer/v1/img/5a70c4caf275f033aa59a522a90dccdf.png",
              fullWidth: 824,
              fullHeight: 886
            }}
          />
        </p.Stack>
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "sourceContainer",
    "source",
    "sourceInner",
    "sourceAddCircle",
    "attentionIndicator",
    "imageFromUrl",
    "sourceTexts",
    "title",
    "handle",
    "link",
    "editingArea",
    "adjustAttentionDiv",
    "adjustAttentionText",
    "adjustAttentionInfoIcon",
    "button",
    "deleteSourceIcon",
    "attentionSelection",
    "addInterestBtn",
    "edit",
    "adjustAttentionButton",
    "adjustAttention",
    "lottie",
    "logo"
  ],
  sourceContainer: [
    "sourceContainer",
    "source",
    "sourceInner",
    "sourceAddCircle",
    "attentionIndicator",
    "imageFromUrl",
    "sourceTexts",
    "title",
    "handle",
    "link",
    "editingArea",
    "adjustAttentionDiv",
    "adjustAttentionText",
    "adjustAttentionInfoIcon",
    "button",
    "deleteSourceIcon",
    "attentionSelection",
    "addInterestBtn",
    "edit",
    "adjustAttentionButton",
    "adjustAttention",
    "lottie",
    "logo"
  ],
  source: [
    "source",
    "sourceInner",
    "sourceAddCircle",
    "attentionIndicator",
    "imageFromUrl",
    "sourceTexts",
    "title",
    "handle",
    "link",
    "editingArea",
    "adjustAttentionDiv",
    "adjustAttentionText",
    "adjustAttentionInfoIcon",
    "button",
    "deleteSourceIcon",
    "attentionSelection",
    "addInterestBtn",
    "edit",
    "adjustAttentionButton",
    "adjustAttention",
    "lottie",
    "logo"
  ],
  sourceInner: [
    "sourceInner",
    "sourceAddCircle",
    "attentionIndicator",
    "imageFromUrl",
    "sourceTexts",
    "title",
    "handle",
    "link",
    "editingArea",
    "adjustAttentionDiv",
    "adjustAttentionText",
    "adjustAttentionInfoIcon",
    "button",
    "deleteSourceIcon",
    "attentionSelection",
    "addInterestBtn",
    "edit",
    "adjustAttentionButton",
    "adjustAttention",
    "lottie"
  ],
  sourceAddCircle: ["sourceAddCircle"],
  attentionIndicator: ["attentionIndicator"],
  imageFromUrl: ["imageFromUrl"],
  sourceTexts: ["sourceTexts", "title", "handle", "link"],
  title: ["title"],
  handle: ["handle", "link"],
  link: ["link"],
  editingArea: [
    "editingArea",
    "adjustAttentionDiv",
    "adjustAttentionText",
    "adjustAttentionInfoIcon",
    "button",
    "deleteSourceIcon",
    "attentionSelection",
    "addInterestBtn"
  ],
  adjustAttentionDiv: [
    "adjustAttentionDiv",
    "adjustAttentionText",
    "adjustAttentionInfoIcon"
  ],
  adjustAttentionText: ["adjustAttentionText"],
  adjustAttentionInfoIcon: ["adjustAttentionInfoIcon"],
  button: ["button", "deleteSourceIcon"],
  deleteSourceIcon: ["deleteSourceIcon"],
  attentionSelection: ["attentionSelection"],
  addInterestBtn: ["addInterestBtn"],
  edit: ["edit", "adjustAttentionButton", "adjustAttention"],
  adjustAttentionButton: ["adjustAttentionButton", "adjustAttention"],
  adjustAttention: ["adjustAttention"],
  lottie: ["lottie"],
  logo: ["logo"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  sourceContainer: "div";
  source: "div";
  sourceInner: "div";
  sourceAddCircle: typeof p.PlasmicImg;
  attentionIndicator: typeof AttentionIndicator;
  imageFromUrl: typeof p.PlasmicImg;
  sourceTexts: "div";
  title: "div";
  handle: "div";
  link: "a";
  editingArea: "div";
  adjustAttentionDiv: "button";
  adjustAttentionText: "div";
  adjustAttentionInfoIcon: "svg";
  button: "button";
  deleteSourceIcon: "svg";
  attentionSelection: typeof AttentionSelection;
  addInterestBtn: "button";
  edit: "div";
  adjustAttentionButton: "div";
  adjustAttention: "div";
  lottie: typeof LottieWrapper;
  logo: typeof p.PlasmicImg;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSource__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSource__VariantsArgs;
    args?: PlasmicSource__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSource__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSource__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSource__ArgProps,
          internalVariantPropNames: PlasmicSource__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSource__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSource";
  } else {
    func.displayName = `PlasmicSource.${nodeName}`;
  }
  return func;
}

export const PlasmicSource = Object.assign(
  // Top-level PlasmicSource renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sourceContainer: makeNodeComponent("sourceContainer"),
    source: makeNodeComponent("source"),
    sourceInner: makeNodeComponent("sourceInner"),
    sourceAddCircle: makeNodeComponent("sourceAddCircle"),
    attentionIndicator: makeNodeComponent("attentionIndicator"),
    imageFromUrl: makeNodeComponent("imageFromUrl"),
    sourceTexts: makeNodeComponent("sourceTexts"),
    title: makeNodeComponent("title"),
    handle: makeNodeComponent("handle"),
    link: makeNodeComponent("link"),
    editingArea: makeNodeComponent("editingArea"),
    adjustAttentionDiv: makeNodeComponent("adjustAttentionDiv"),
    adjustAttentionText: makeNodeComponent("adjustAttentionText"),
    adjustAttentionInfoIcon: makeNodeComponent("adjustAttentionInfoIcon"),
    button: makeNodeComponent("button"),
    deleteSourceIcon: makeNodeComponent("deleteSourceIcon"),
    attentionSelection: makeNodeComponent("attentionSelection"),
    addInterestBtn: makeNodeComponent("addInterestBtn"),
    edit: makeNodeComponent("edit"),
    adjustAttentionButton: makeNodeComponent("adjustAttentionButton"),
    adjustAttention: makeNodeComponent("adjustAttention"),
    lottie: makeNodeComponent("lottie"),
    logo: makeNodeComponent("logo"),

    // Metadata about props expected for PlasmicSource
    internalVariantProps: PlasmicSource__VariantProps,
    internalArgProps: PlasmicSource__ArgProps
  }
);

export default PlasmicSource;
/* prettier-ignore-end */
